<ng-container *ngIf="data">
  <div class="wrapp">
    <h3 *ngIf="data?.name" class="section-name">{{ data.name }}</h3>
    <h2 class="section-title title-additional" *ngIf="!data.isBigTitle">{{ data.title }}</h2>
    <h1 class="section-title title" *ngIf="data.isBigTitle">{{ data.title }}</h1>
    <p class="section-description description-secondary">{{ data.descriptions }}</p>
  </div>
</ng-container>
